import { render, staticRenderFns } from "./UtilizationSummary.vue?vue&type=template&id=327c90c2"
import script from "./UtilizationSummary.vue?vue&type=script&lang=js"
export * from "./UtilizationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports